/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';
import { map } from 'lodash';

import type { TaskDetails } from '@/task-manager/entities/task-details';
import type { TaskFile } from '@/task-manager/entities/task-file';
import { Optimistic } from '@/utils/react-query/optimistic';

import {
  type BodyOf,
  type FilesListOutputRead,
  tasksV1CardsFilesListRetrieve,
} from '../fetch-client';
import { taskFileMapper } from '../mappers/task-file';
import { useFetchOpts } from '../use-fetch-opts';

export namespace ListTaskFiles {
  export const key = (task: TaskDetails) => [
    'task-manager',
    'list-task-files',
    task.id,
  ];

  export type QueryParams = {
    refetchInterval?: number;
  };

  export type Input = { task: TaskDetails };

  export type Output = { files: TaskFile[] };

  function bodyFromInput(
    input: Input,
  ): BodyOf<typeof tasksV1CardsFilesListRetrieve> {
    return { uuid: input.task.id };
  }

  function outputFromBody(data: FilesListOutputRead): Output {
    return { files: map(data.files, taskFileMapper) };
  }

  export const optimistic = Optimistic.makeUpdate<Output>();

  export function useQuery(
    input: Input,
    { refetchInterval }: QueryParams = {},
  ) {
    const getOpts = useFetchOpts();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input.task),
      async queryFn({ signal }) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        const data = await ok(
          tasksV1CardsFilesListRetrieve(body, {
            ...opts,
            signal,
          }),
        );
        return outputFromBody(data);
      },
    });
  }
}
